import { ScenarioPassCriteria } from 'components/scenarios/concurrent/concurrent-scenario-form-utils'

export type PolicyCategory =
  | 'REDUNDANCY'
  | 'SCALABILITY'
  | 'DEPENDENCIES'
  | 'RISKS'
  | 'OTHER'

export type PolicyCategoryLabel =
  | 'Redundancy'
  | 'Scalability'
  | 'Dependencies'
  | 'Other'

export type PolicyTarget = 'SERVICE' | 'SERVICE_DEPENDENCY'

export enum PolicyResult {
  PASSED = 'PASSED',
  FAILED = 'FAILED',
  NEVER_RUN = 'NEVER_RUN',
  IGNORED = 'IGNORED',
  EXPIRED = 'EXPIRED'
}

export interface PolicyEvaluation {
  dependencyId?: string | null
  description?: string
  diagnosisAvailable?: boolean // see src/types/api/reliability-tests/runs.d.ts for more details
  /* For reliability tests this is when the test completed */
  evaluationTime?: EpochTimeStamp // Null if never run
  failureFlagName?: string | null // failureFlagName is only present on failure flag service (not dependency) tests
  name: string
  order: number
  passCriteria: ScenarioPassCriteria
  policyId: string // UUID
  reliabilityTestId: string // Copied for collating on the client side
  result: PolicyResult
  runNumber?: number
  scenarioId?: string
  serviceId: string
  staleness: EpochTimeStamp
}

export interface Policy {
  order?: number
  name: string
  description?: string
  policyCategory: PolicyCategory
  policyTarget: PolicyTarget
  reliabilityTestId: string
  staleness?: number // specifies expiration window, not editable
}
